import { Routes } from '@angular/router';

export const tradeOptionDetailsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./trade-option-details.page').then(
        (m) => m.TradeOptionDetailsPage
      ),
  },
];
